import inherits from 'inherits';

import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';

import { is } from '../../../base/BaseServices';


/**
 * BPMN specific remove behavior
 */
export default function RemoveParticipantAction(eventBus, modeling) {
  CommandInterceptor.call(this, eventBus);

  this.preExecute('shape.delete', function(context) {
    const shape = context.shape;
    
    // Activate the behavior if the shape to be removed is a participant
    if (is(shape, 'bpmn:Participant')) {
      context.collaborationRoot = shape.parent;
    }
  }, true);

  this.postExecute('shape.delete', function(context) {
    const collaborationRoot = context.collaborationRoot;

    if (collaborationRoot && !collaborationRoot.businessObject.participants.length) {
      // Replace empty collaboration with process diagram
      modeling.makeProcess();
    }
  }, true);
}


RemoveParticipantAction.$inject = [ 'eventBus', 'modeling' ];

inherits(RemoveParticipantAction, CommandInterceptor);